/**
 * Checkpoint Module - Main barrel export
 *
 * This module provides a refactored, modular architecture for checkpoint conversations.
 *
 * Structure:
 * - hooks/: Custom hooks for state management
 *   - useConversationState: State machine for conversation flow
 *   - useCheckpointTimer: Timer for close button visibility
 *   - usePhotoCapture: Photo capture handling
 *   - useLiveKitSync: LiveKit attribute synchronization
 *
 * - components/: Reusable UI components
 *   - CheckpointHeader: Header with petal badge and close button
 *   - ConversationBubble: Sam's message bubble
 *   - ResponseOptions: Clickable response options
 *   - FeedbackButtons: Thumbs up/down feedback
 *
 * - constants.js: Shared constants and helper functions
 */

// Hooks
export * from "./hooks"

// Components
export * from "./components"

// Constants
export * from "../../../engine/precall/checkpoint/constants"
